import $ from 'jquery'
var pingerInitialized = false
var minutes = 2;
var timeoutId


export default function  pingEventAttendeeActive (currentEventAttendee) {
  if (pingerInitialized) return;
  var eventAttendeeId = currentEventAttendee && currentEventAttendee.id
  if (!eventAttendeeId) {
    console.error('no current event attendee for ping')
    return
  }

  var updateUrl = `/event_attendee_presence/${currentEventAttendee.id}`
  function updateEventAttendeeActive () {
    $.ajax({
      url: updateUrl,
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      data: {},
      success: function (res) {
        timeoutId = pingServerOnTimeout()
      }.bind(this),
      error: function (err) {
        console.log(err)
        timeoutId =pingServerOnTimeout()
      }.bind(this)
    })
  }
  
  function pingServerOnTimeout () {
    timeoutId = setTimeout(updateEventAttendeeActive, 1000 * 60 * minutes)
  }
  updateEventAttendeeActive()
  pingerInitialized = true
}